import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ParamethorService } from '~/paramethor/paramethor.service';
import { ParamethorNameEnum } from '~/paramethor/names.enum';

@Directive({
  selector: '[flagIsTrue]',
})
export class FlagIsTrueDirective {
  constructor(
    private readonly paramethorService: ParamethorService,
    private readonly templateRef: TemplateRef<Element>,
    private readonly viewContainer: ViewContainerRef
  ) {}

  @Input() set flagIsTrue(name: ParamethorNameEnum) {
    const isEnabled = this.paramethorService.isTrue(name);
    if (isEnabled) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    this.viewContainer.clear();
  }
}
